import requestDefault from '@/shared/utils/request';
import { AgreementListData, QueryAgreementParams, SubmitAgreementParams } from './types';

/**
 * 协议签署接口-聚合版(臻有钱用户协议、平台协议、活体协议、征信路由协议)
 * yapi地址:
 * 接口服务: 杨钊
 */
export const submitAgreement = (
  params: SubmitAgreementParams,
): Promise<void> => requestDefault.postGate(
  'f.ocrAfter.loan.submitAgreement',
  {
    ...params,
  },
);

/**
 * 查询待签署协议列表
 * yapi地址:
 * 接口服务: 杨钊
 */
export const queryAgreement = (
  params?: QueryAgreementParams,
): Promise<AgreementListData> => requestDefault.postGate(
  'f.ocrAfter.loan.queryAgreement',
  {
    ...params,
  },
);

export const ConvergeAgreementApi = {
  queryAgreement,
  submitAgreement,
};
